import Fade from "@mui/material/Fade";
import MuiMenu from "@mui/material/Menu";
import MuiMenuItem from "@mui/material/MenuItem";
import { useRequiredContext } from "@redotech/react-util/context";
import { ReactNode, createContext, memo, useMemo, useState } from "react";
import { IconButton } from "./button";
import MeatballsIcon from "./icon-old/meatballs.svg";

export interface MenuInfo {
  close(): void;
}

const MenuContext = createContext<MenuInfo | undefined>(undefined);

export const ButtonMenu = memo(function ButtonMenu({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);
  return (
    <>
      <IconButton onClick={() => setOpen(true)} ref={setAnchor}>
        <MeatballsIcon />
      </IconButton>
      <Menu anchor={anchor} onClose={() => setOpen(false)} open={open}>
        {children}
      </Menu>
    </>
  );
});

export const Menu = memo(function Menu({
  anchor,
  children,
  open,
  onClose,
}: {
  anchor: HTMLElement | null;
  children: ReactNode | ReactNode[];
  open: boolean;
  onClose?(): void;
}) {
  const menuInfo: MenuInfo = useMemo(
    () => ({ close: onClose || (() => {}) }),
    [onClose],
  );
  return (
    <MenuContext.Provider value={menuInfo}>
      <MuiMenu
        anchorEl={anchor}
        onClose={onClose}
        open={open}
        TransitionComponent={Fade}
      >
        {children}
      </MuiMenu>
    </MenuContext.Provider>
  );
});

export const MenuItem = memo(function MenuItem({
  children,
  onClick,
}: {
  children: ReactNode | ReactNode[];
  onClick?(): void;
}) {
  const menuInfo = useRequiredContext(MenuContext);
  const handleClick = () => {
    menuInfo.close();
    onClick?.();
  };
  return <MuiMenuItem onClick={handleClick}>{children}</MuiMenuItem>;
});
